import {UserNotificationPreferences} from "@/models/entities/ModelHelpers";
import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";

export default class User {
  id: number = -1;
  displayName: string = '';
  firstName?: string | null = null;
  lastName?: string | null = null;
  email: string = '';
  role: string = 'User';
  initials: string = '';
  notifications: UserNotificationPreferences = new UserNotificationPreferences();
  isActive: boolean = true;
  createdAt: string = getGermanIsoString();

  constructor(data: Record<string, any> | undefined = undefined) {
    Object.assign(this, data);
  }
}